import React from 'react';

import { useStyles } from './styles';

export const Box = ({
  children,
  padding,
  margin,
  classes = {},
  style
}: BoxProps) => {
  const innerClasses = useStyles({ padding, margin });
  return (
    <div
      className={`${innerClasses.container} ${classes.root}`}
      style={style}
    >
      {children}
    </div>
  );
};

type Spacing = {
  [key in 'top' | 'right' | 'bottom' | 'left']?: number;
}

interface Classes {
  root?: string;
}
export interface BoxProps {
  padding?: Spacing | number;
  margin?: Spacing | number;
  children: React.ReactNode;
  classes?: Classes;
  style?: React.CSSProperties;
}
